module.exports = __webpack_public_path__ + "img/add-circle-outline-black.a315f0df.svg";